import React, { useState } from "react";
import { secureStorage } from "./utils/secureStorage";
import "./Login.css";

// ✅ Use environment variable
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const Login = ({ onSwitchToRegister, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
  
    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }
  
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
  
      const data = await response.json();
      console.log("is_super_admin from server:", data.is_super_admin);
  
      if (!response.ok) {
        setError(data.detail || "Login failed.");
        return;
      }
  
      // ✅ Bundle all encrypted storage entries
      const itemsToStore = {
        token: data.access_token,
        refreshToken: data.refresh_token,
        role: data.role,
        isSuperAdmin: data.is_super_admin ? "true" : "false",
        email: data.email,
        organization_id: data.organization_id,
        organization_name: data.organization_name,
        tier: data.tier_name || "Free",
        theme: data.theme || "dark",
        max_users: data.max_users,
        accessExpiresAt: data.access_expires_at || "",
      };
  
      Object.entries(itemsToStore).forEach(([key, value]) => {
        secureStorage.setItem(key, value);
      });
  
      console.log("✅ All data stored successfully");
  
      setError("");
      
      try {
        await onLoginSuccess(); // ✅ Wrap this in its own try-catch
        console.log("✅ onLoginSuccess completed");
      } catch (loginSuccessError) {
        console.error("❌ onLoginSuccess failed:", loginSuccessError);
        setError("Login successful but navigation failed. Please refresh the page.");
        return;
      }
  
    } catch (err) {
      console.error("❌ Full login error:", err);
      setError("Something went wrong. Please try again.");
    }
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault(); // ✅ Prevent default form submission

  //   if (!email || !password) {
  //     setError("Email and password are required.");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`${API_BASE_URL}/login`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ email, password }),
  //     });

  //     const data = await response.json();
  //     console.log("is_super_admin from server:", data.is_super_admin);

  //     if (!response.ok) {
  //       setError(data.detail || "Login failed.");
  //       return;
  //     }

  //     // ✅ Bundle all encrypted storage entries
  //     const itemsToStore = {
  //       token: data.access_token,
  //       refreshToken: data.refresh_token,
  //       role: data.role,
  //       isSuperAdmin: data.is_super_admin ? "true" : "false",
  //       email: data.email,
  //       organization_id: data.organization_id,
  //       organization_name: data.organization_name,
  //       tier: data.tier_name || "Free",
  //       theme: data.theme || "dark",
  //       max_users: data.max_users,
  //       accessExpiresAt: data.access_expires_at || "",
  //     };

  //     Object.entries(itemsToStore).forEach(([key, value]) => {
  //       secureStorage.setItem(key, value); // ✅ Using encrypted storage from utils
  //     });

  //     setError("");
  //     await onLoginSuccess(); // Notify App.js AFTER all values stored
  //   } catch (err) {
  //     console.error("Login error:", err);
  //     setError("Something went wrong. Please try again.");
  //   }
  // };

  return (
    <div className="auth-container">
      <h2>Login</h2>
      {error && <p className="auth-error">{error}</p>}

      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          className="auth-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="auth-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" className="auth-button">
          Login
        </button>
      </form>

      <p>
        Don't have an account?{" "}
        <span className="auth-switch" onClick={onSwitchToRegister}>
          Register here
        </span>
      </p>
    </div>
  );
};

export default Login;


// import React, { useState } from "react";
// import "./Login.css";

// // ✅ Use environment variable
// const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

// const Login = ({ onSwitchToRegister, onLoginSuccess }) => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault(); // ✅ Prevent default form submission

//     if (!email || !password) {
//       setError("Email and password are required.");
//       return;
//     }

//     try {
//       const response = await fetch(`${API_BASE_URL}/login`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await response.json();
//       console.log("is_super_admin from server:", data.is_super_admin);

//       if (!response.ok) {
//         setError(data.detail || "Login failed.");
//         return;
//       }

//       // ✅ Bundle all localStorage entries first
//       const itemsToStore = {
//         token: data.access_token,
//         refreshToken: data.refresh_token,
//         role: data.role,
//         isSuperAdmin: data.is_super_admin ? "true" : "false",
//         email: data.email,
//         organization_id: data.organization_id,
//         organization_name: data.organization_name,
//         tier: data.tier_name || "Free",
//         theme: data.theme || "dark",
//         max_users: data.max_users,
//         accessExpiresAt: data.access_expires_at || "",
//       };

//       Object.entries(itemsToStore).forEach(([key, value]) => {
//         localStorage.setItem(key, value);
//       });

//       setError("");
//       await onLoginSuccess(); // Notify App.js AFTER all values stored
//     } catch (err) {
//       console.error("Login error:", err);
//       setError("Something went wrong. Please try again.");
//     }
//   };

//   return (
//     <div className="auth-container">
//       <h2>Login</h2>
//       {error && <p className="auth-error">{error}</p>}

//       <form onSubmit={handleLogin}>
//         <input
//           type="email"
//           placeholder="Email"
//           className="auth-input"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           className="auth-input"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />

//         <button type="submit" className="auth-button">
//           Login
//         </button>
//       </form>

//       <p>
//         Don't have an account?{" "}
//         <span className="auth-switch" onClick={onSwitchToRegister}>
//           Register here
//         </span>
//       </p>
//     </div>
//   );
// };

// export default Login;

